import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Data } from '@angular/router';
import { filter } from 'rxjs/operators';

export abstract class ReduxModel<T> {
    protected model: T;

    constructor(
        private readonly st: Store<any>,
        private readonly selector: string,
        private readonly actionEvent: any,
    ) {
        this.st.select(`${ selector }`)
            .pipe(filter((state: T) => {
                if (state instanceof Array) {
                    return state && !!state.length;
                } else {
                    return state && !!Object.keys(state).length;
                }
            }))
            .subscribe((state: T) => this.model = state);
    }

    public get data() {
        return this.model;
    }

    public set data(model: T) {
        this.model = model;

        this.st.dispatch(new this.actionEvent(model));
    }

    public getState(): Observable<T> {
        return this.st.select(`${ this.selector }`);
    }
}
